import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { List } from 'immutable'

import Modal from 'components/shared/Modal'
import { encodeQueryData } from 'utils/Helpers'
import { popUp } from 'components/Integration/helpers'
import { getApplication } from 'app/Application'
import { APP_URL, GOOGLE_CLIENT_ID } from 'constants/ResourcesConstants'
import { GoogleScopes } from 'app/modules/integrations/constants'

import { fetchGoogleScopesSuccess } from 'app/modules/user/actions'
import { hideGoogleAuthModal } from 'app/modules/playbook/actions'

import style from './style.styl'

const APP = getApplication()
const GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth'

class GoogleAuthModal extends Component {
  doGmailConnect = () => {
    const scope = `${GoogleScopes.READ} ${GoogleScopes.SEND}`
    const params = {
      scope,
      redirect_uri: `${APP_URL}/accept-integration/google-calendar`,
      client_id: GOOGLE_CLIENT_ID,
      response_type: 'code',
      access_type: 'offline',
      include_granted_scopes: true,
    }

    popUp({
      path: `${GOOGLE_AUTH_URL}?${encodeQueryData(params)}`,
      onMessage: this.handlePostMessage,
    })
  }

  handlePostMessage = e => {
    const { onSuccess } = this.props
    const success = e.data.status === 'success'
    this.props.actions.hideGoogleAuthModal()
    if (success) {
      APP.actions.NotificationActions.pushNotification({
        content: 'Your Google account was successfully connected.',
      })
      !!onSuccess && onSuccess(e)
      this.props.actions.fetchGoogleScopesSuccess(List.of(GoogleScopes.READ, GoogleScopes.SEND))
    } else {
      APP.actions.NotificationActions.pushNotification({
        content: (
          <span>
            Your Google account may be connected to a different Drift account. Please review your{' '}
            <a
              style={{ color: '#EFEFEF', textDecoration: 'underline' }}
              href="https://myaccount.google.com/permissions"
              target="_blank"
            >
              Google app permissions
            </a>.
          </span>
        ),
        variant: 'red',
        sticky: true,
      })
    }
  }

  render() {
    const { onClose } = this.props

    return (
      <Modal
        onRequestClose={onClose}
        isOpen={true}
        style={{ content: { padding: 0, border: '1px solid transparent', background: 'none' }}}
      >
        <div className="drift-modal link-google-auth-modal">
          <h2>One quick thing…</h2>
          <p>
            In order for you to send a test email, we need you to connect your Gmail account. Learn more{' '}
            <a href="https://help.drift.com/sequences/connect-your-email-to-drift-sequences" target="_blank">
              here
            </a>.
          </p>

          <footer>
            <button className="drift-button" onClick={this.props.actions.hideGoogleAuthModal}>
              Cancel
            </button>
            <button className="drift-button drift-button-primary" onClick={this.doGmailConnect}>
              Link Gmail Account
            </button>
          </footer>
        </div>
      </Modal>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        hideGoogleAuthModal,
        fetchGoogleScopesSuccess,
      },
      dispatch
    ),
  }
}

export default connect(undefined, mapDispatchToProps)(GoogleAuthModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/GoogleAuthModal/index.js